import {Brick, BrickContext, registerBrick, Transaction, File as OFile, ErrorFlow, CloudObject} from 'olympe';
import { getLogger } from '@olympeio/core';
import Compressor from 'compressorjs';

export default class CompressPicture extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {File} file
     * @param {number} maxHeight
     * @param {number} quality
     * @param {function()} forwardEvent
     * @param {function(*)} setErrorFlow
     * @param {function(File)} setResult
     */
    update($, [file, maxHeight, quality], [forwardEvent, setErrorFlow, setResult]) {
        // If quality is >= 1, no compression is required
        const logger = getLogger('CompressPicture');
        if (quality >= 1) {
            logger.warn(`Trying to compress an image with a quality >= 1 (${quality}). No compression is required.`);
            setResult(file);
            forwardEvent();
            return;
        }

        // Read file data
        file.getContentAsBinary().then((content) => {
            const mimeType = file.get(OFile.mimeTypeProp);
            const filename = file.get(OFile.fileNameProp);

            // Convert to Blob format
            const blob = new Blob([content], {type: mimeType});

            // Start compressing image
            new Compressor(blob, {
                quality,
                height: maxHeight,
                success: async (result) => {
                    // Init transaction
                    const transaction = new Transaction(false);

                    // Get response as a Blob, create file for DC
                    const fileTag = transaction.create(OFile);
                    OFile.setContent(transaction, fileTag, filename, await result.arrayBuffer(), mimeType);

                    // Execute transaction
                    transaction.execute().then(() => {
                        // On success set new result image
                        setResult(CloudObject.get(fileTag));
                        forwardEvent();
                    }).catch((e) => {
                        setErrorFlow(ErrorFlow.create(`Failed to create ImageFile object with compressed image file: ${e}`, 2));
                    });
                }, error: (e) => {
                    setErrorFlow(ErrorFlow.create(`Failed to compress image file: ${e}`, 1));
                },
            })
        }).catch(
            (errorMsg) => {
                setErrorFlow(ErrorFlow.create(`Failed to fetch content url: ${errorMsg}`, 0));
        });
    }
}

registerBrick('01888f8168f396f50329', CompressPicture);